import { render, staticRenderFns } from "./BoxUser.vue?vue&type=template&id=8b2500a2"
import script from "./BoxUser.vue?vue&type=script&lang=js"
export * from "./BoxUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports